import { Component, AfterViewInit , Input, ViewChildren} from '@angular/core';
import { pagination } from "../../language/pagination";
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements AfterViewInit  {
  @Input("mfTable") mfTable:any;
  @Input("lang") lang:any;
  @Input("rowsOnPageSet") rowsOnPageSet = [];
  @ViewChildren("p") p:any;
  minRowsOnPage=0;
  math=Math;
  lists:any=[1,2,3];
  page=1;
  page_num="5";
  language:any;
  constructor(private route:ActivatedRoute) {

   }

  ngAfterViewInit() {

    this.setlist();
    this.route.queryParams.subscribe(params => {
      this.lang= params['lang'];
      if(this.lang!='EN'&&this.lang!='TH'){
        this.lang=localStorage.getItem('lang')=='EN'?'EN':'TH';
        this.language=pagination[this.lang];
      }else{
        this.language=pagination[this.lang];
        localStorage.setItem('lang',this.lang);
      }
   });
  }
  setlist(){
    //console.log(this.p);
    this.lists=[];
    for(var i=0;i<this.p.last.lastPage;i++){
      this.lists.push(i+1);
    }
    this.page=1;
    //console.log(this.lists);
  }
    ngOnChanges(changes: any): any {
      // this.page=
      this.language=pagination[this.lang];
    //console.log(this.language);
      //console.log("change");
        if (changes.rowsOnPageSet) {
            this.minRowsOnPage = Math.min(...this.rowsOnPageSet)
        }
    }
    change_row(p,row){
      p(parseInt(row));
    }
    parseInt(){
      return parseInt;
    }
}
